module.exports = __webpack_public_path__ + "img/Landesverband.ba37acbd.svg";